<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    ></BlockUI>
    <div>
      <div>
        <el-row>
          <el-col>
            <div class="card-header">
              <div style="margin-top:10px; margin-left:30px; margin-right:30px">
                <div style>
                  <div class="form-group">
                    <h3>Configurações</h3>
                  </div>
                  <div class="col-md-12">
                    <label for="model">Cliente:</label>
                    <select
                      @change="getConfigurations()"
                      class="form-control"
                      name="model"
                      v-model="client_id"
                      required
                    >
                      <option
                        v-for="(client, index) in clients"
                        :key="index"
                        :value="client.id"
                        >{{ client.name }}</option
                      >
                    </select>
                  </div>
                  <br />
                  <div
                    class="form-group form-row mb-1"
                    v-if="configItems || configItems.length >= 1"
                  >
                    <div
                      v-for="(config, key) in configItems"
                      :key="key"
                      class="col-md-12 col-lg-12 mb-3"
                    >
                      <label>{{ config.display_name }}</label>
                      <br />
                      <small class="form-text text-muted">{{
                        config.description
                      }}</small>
                      <!-- IF PARA COLOCAR UM INPUT FILE QUANDO A CONFIGURAÇÃO FOR DE TERMOS DE USO -->
                      <div class="input-group" v-if="key == 'term_of_use'">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="inputGroupFile01"
                            @change="uploadFile($event, 'term_of_use')"
                            aria-describedby="inputGroupFileAddon01"
                          />
                          <!-- O tratamento do nome do pdf dentro da label esta sendo feito para não exibir a url completa da aws.  -->
                          <label
                            class="custom-file-label"
                            for="inputGroupFile01"
                            >{{
                              config.value !== ''
                                ? config.value.name ||
                                  config.value.substring(
                                    config.value.lastIndexOf('/') + 1
                                  ) + '.pdf'
                                : 'Selecione um pdf'
                            }}</label
                          >
                        </div>
                      </div>
                      <div class="input-group" v-else-if="key == 'logo'">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="inputGroupFile02"
                            @change="uploadFile($event, 'logo')"
                            aria-describedby="inputGroupFileAddon01"
                          />
                          <!-- O tratamento do nome do pdf dentro da label esta sendo feito para não exibir a url completa da aws.  -->
                          <label
                            class="custom-file-label"
                            for="inputGroupFile02"
                            >{{
                              config.value !== ''
                                ? config.value.name ||
                                  config.value.substring(
                                    config.value.lastIndexOf('/') + 1
                                  ) + '.png'
                                : 'Selecione uma imagem'
                            }}</label
                          >
                        </div>
                      </div>
                      <div
                        class="input-group"
                        v-else-if="key == 'logo_light_background'"
                      >
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="inputGroupFile03"
                            @change="
                              uploadFile($event, 'logo_light_background')
                            "
                            aria-describedby="inputGroupFileAddon03"
                          />
                          <!-- O tratamento do nome do pdf dentro da label esta sendo feito para não exibir a url completa da aws.  -->
                          <label
                            class="custom-file-label"
                            for="inputGroupFile03"
                            >{{
                              config.value !== ''
                                ? config.value.name ||
                                  config.value.substring(
                                    config.value.lastIndexOf('/') + 1
                                  ) + '.png'
                                : 'Selecione uma imagem'
                            }}</label
                          >
                        </div>
                      </div>

                      <input
                        placeholder
                        class="form-control"
                        v-model="configItems[key].value"
                        v-else
                      />
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                      <button
                        type="button"
                        class="btn-block btn btn-primary mb-2 new-driver-button"
                        @click="save()"
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import ConfigurationController from '../../controllers/ConfigurationController.js';
import ClientController from '../../controllers/ClientController.js';
import Configuration from '../../models/Configuration.js';
import { required, minLength, between } from 'vuelidate/lib/validators';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import { setThemeColors } from '../../helpers/Theming';
export default {
  created() {
    this.clientController = new ClientController(this.$resource);
    this.configurationController = new ConfigurationController(this.$resource);
    this.getClients();
    this.dialog = true;
  },
  validations: {
    code: {
      required,
      minLength: minLength(3),
    },
  },
  data() {
    return {
      code: '',
      description: '',
      headers: [
        { text: 'Código', value: 'code' },
        { text: 'Descrição', value: 'description' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      configItems: {},
      client_id: 0,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      Configuration: new Configuration(),
      clients: [],
      selectedRow: [],
    };
  },
  methods: {
    getClients() {
      this.clientController
        .getAllClients()
        .then(clients => (this.clients = clients));
    },
    getConfigurations() {
      this.configurationController
        .getAllConfigurationByClientId(this.client_id)
        .then(res => {
          this.configItems = res;
          this.blockScreen = false;
        });
    },
    uploadFile(event, entry) {
      let file = event.target.files[0];
      this.configItems[entry].value = file;
    },
    async save() {
      // O update das configurações é feito somente com a chave e valor. Title e Description estã no ConfigurationRepository do backend.
      let newItems = {};
      let form_data = new FormData();
      Object.keys(this.configItems).map(idx =>
        form_data.append(
          this.configItems[idx]['key'],
          this.configItems[idx]['value']
        )
      );
      await this.$awn.asyncBlock(
        this.configurationController.update(form_data, this.client_id).then(
          res => {
            if (res.success) {
              this.$awn.success(res.message);
            } else {
              this.$awn.warning(res.message);
            }
            this.getConfigurations();
          },
          err => {
            this.$awn.warning(res.message);
          }
        ),
        false,
        false,
        'Carregando'
      );

      await setThemeColors();
    },
    cleanForm() {
      this.Configuration = new Configuration();
    },
    handleSelectionChange(val) {
      this.selectedRow = val;
    },
  },
};
</script>
<style>
.buttons-action td:last-child div {
  text-align: right;
}
.buttons-action td:last-child div button {
  margin-left: 2px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.buttons-action th:last-of-type div {
  margin-left: 11px;
  text-align: center;
}
.btn-cancel {
  margin-right: 10px !important;
  color: #fff;
  background-color: #ff3939;
  border-color: #ef3f3f;
}
.btn-cancel:hover {
  background: #f78989;
  border-color: #f78989;
  color: #fff;
}

.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
/* .table-custom-vue thead tr th:nth-of-type(3){
  float: right;
  margin-top: 20px;
} */

.btn.save {
  background-color: var(--primary-color);
  color: #222;
}
</style>
